<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  .mapping-grid {
    display: grid;
    gap: utils.in_rem(25px);
    padding: utils.in_rem(32px) 0 utils.in_rem(32px) utils.in_rem(50px);

    .map {
      display: grid;
      gap: utils.in_rem(12px);
    }
  }
</style>

<script>
  import SettingMappingRow from "../../../components/shared/MappingGrid/SettingMappingRow.svelte";

  import { integrationStore } from "../../../stores";

  export let type;

  $: settings = $integrationStore.getSettings("stages", type);
</script>

<div class="mapping-grid">
  <SettingMappingRow
    sourceLabel="SourceWhale"
    targetLabel={$integrationStore.getProviderTitle()}
    header
  />

  {#if settings.length}
    <div class="map">
      {#each settings as setting}
        <SettingMappingRow {setting} {type} />
      {/each}
    </div>
  {/if}
</div>
